import styled from 'styled-components';

export const ZoomContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ZoomButton = styled.button`
  width: 32px;
  height: 32px;
  border: 1px solid #e0e0e0;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  
  span {
    font-size: 18px;
    line-height: 1;
    color: #666;
  }

  &:hover:not(:disabled) {
    background: #f5f5f5;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const ZoomFactor = styled.div`
  font-size: 12px;
  color: #666;
  text-align: center;
  margin: 4px 0;
  width: 32px;
`;

export const TreeContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  touch-action: none;
  
  svg {
    width: 100%;
    height: 100%;
    max-height: 80vh;
    touch-action: none;
  }
`;
